import React from "react";
import HelperText from "../../../../../components/atoms/HelperText";
import { alphaMissenseUrl } from "../InSilicoPredictionsUrls";

export function scoresExplanation(databaseName) {
  switch (databaseName) {
    case "SIFT":
      return (
        <HelperText
          customText="SIFT score (SIFTori). Scores range from 0 to 1. The smaller the score the
  more likely the SNP has damaging effect."
        />
      );

    case "SIFT4G":
      return (
        <HelperText
          customText="SIFT 4G score (SIFT4G). Scores range from 0 to 1. The smaller the score the
  more likely the SNP has damaging effect."
        />
      );

    case "PROVEAN":
      return (
        <HelperText
          customText="PROVEAN score (PROVEANori). Scores range from -14 to 14. The smaller the score
  the more likely the SNP has damaging effect."
        />
      );

    case "MVP":
      return (
        <HelperText
          customText="A pathogenicity prediction score for missense variants using deep learning approach.
  The range of MVP score is from 0 to 1. The larger the score, the more likely the variant is 
  pathogenic. The authors suggest thresholds of 0.7 and 0.75 for separating damaging vs tolerant 
  variants in constrained genes (ExAC pLI >=0.5) and non-constrained genes (ExAC pLI<0.5), respectively. 
  For details see doi: http://dx.doi.org/10.1101/259390"
        />
      );

    case "MutPred":
      return (
        <HelperText
          customText="General MutPred score. Scores range from 0 to 1. The larger the score the more
  likely the SNP has damaging effect."
        />
      );

    case "PrimateAI":
      return (
        <HelperText
          customText="A pathogenicity prediction score for missense variants based on common variants of
  non-human primate species using a deep neural network. The range of PrimateAI score is 0 to 1. 
  The larger the score, the more likely the variant is pathogenic. The authors suggest a threshold
  of 0.803 for separating damaging vs tolerant variants. 
  For details see https://doi.org/10.1038/s41588-018-0167-z"
        />
      );

    case "BayesDel noAF":
      return (
        <HelperText
          customText="A deleteriousness prediction meta-score for SNVs and indels without inclusion of MaxAF.
  See https://doi.org/10.1002/humu.23158 for details. The range of the score in dbNSFP is from -1.31914 to 0.840878.
  The higher the score, the more likely the variant is pathogenic. The author suggested cutoff between 
  deleterious ('D') and tolerated ('T') is -0.0570105."
        />
      );

    case "BayesDel addAF":
      return (
        <HelperText
          customText="A deleteriousness prediction meta-score for SNVs and indels with inclusion of MaxAF.
  See https://doi.org/10.1002/humu.23158 for details. The range of the score in dbNSFP is from -1.11707 to 
  0.750927. The higher the score, the more likely the variant is pathogenic. The author suggested cutoff 
  between deleterious ('D') and tolerated ('T') is 0.0692655."
        />
      );

    case "LIST-S2":
      return (
        <HelperText
          customText="A deleteriousness prediction score for nonsynonymous SNVs. See https://doi.org/10.1093/nar/gkaa288.
  for details. The range of the score in dbNSFP is from 0 to 1.
  The higher the score, the more likely the variant is pathogenic. The author suggested cutoff between 
  deleterious ('D') and tolerated ('T') is 0.85."
        />
      );

    case "MutationTaster":
      return (
        <HelperText
          customText="MutationTaster p-value (MTori), ranges from 0 to 1. 
  Information on corresponding transcript(s) can 
  be found by querying http://www.mutationtaster.org/ChrPos.html"
        />
      );

    case "Mutation assessor":
      return (
        <HelperText
          customText="MutationAssessor functional impact combined score (MAori). The
  score ranges from -5.17 to 6.49 in dbNSFP."
        />
      );

    case "FATHMM":
      return (
        <HelperText
          customText="FATHMM default score (weighted for human inherited-disease mutations with
  Disease Ontology) (FATHMMori). Scores range from -16.13 to 10.64. The smaller the score 
  the more likely the SNP has damaging effect."
        />
      );

    case "FATHMM-MKL":
      return (
        <HelperText
          customText="FATHMM-MKL p-values. Scores range from 0 to 1. SNVs with scores >0.5
  are predicted to be deleterious, and those <0.5 are predicted to be neutral or benign. 
  Scores close to 0 or 1 are with the highest-confidence. Coding scores are trained using 10
  groups of features. More details of the score can be found in 
  doi: 10.1093/bioinformatics/btv009."
        />
      );

    case "FATHMM-XF":
      return (
        <HelperText
          customText="FATHMM-XF p-values. Scores range from 0 to 1. SNVs with scores >0.5
  are predicted to be deleterious, and those <0.5 are predicted to be neutral or benign. 
  Scores close to 0 or 1 are with the highest-confidence. Coding scores are trained using 10
  groups of features. More details of the score can be found in 
  doi: 10.1093/bioinformatics/btx536."
        />
      );

    case "LRT":
      return (
        <HelperText customText="The original LRT two-sided p-value (LRTori), ranges from 0 to 1." />
      );

    case "DEOGEN2":
      return (
        <HelperText
          customText="A deleteriousness prediction score 'which incorporates heterogeneous information about
  the molecular effects of the variants, the domains involved, the relevance of the gene and the 
  interactions in which it participates'. It ranges from 0 to 1. The larger the score, the more 
  likely the variant is deleterious. The authors suggest a threshold of 0.5 for separating damaging 
  vs tolerant variants."
        />
      );

    case "M-CAP":
      return (
        <HelperText
          customText="M-CAP is hybrid ensemble score (details in DOI: 10.1038/ng.3703). Scores range 
  from 0 to 1. The larger the score the more likely the SNP has damaging effect. "
        />
      );

    case "DANN":
      return (
        <HelperText
          customText="DANN is a functional prediction score retrained based on the training data
  of CADD using deep neural network. Scores range from 0 to 1. A larger number indicate 
  a higher probability to be damaging. More information of this score can be found in
  doi: 10.1093/bioinformatics/btu703. "
        />
      );

    case "MetaLR":
      return (
        <HelperText
          customText="A logistic regression (LR) based ensemble prediction score, which
  incorporated 10 scores (SIFT, PolyPhen-2 HDIV, PolyPhen-2 HVAR, GERP++, MutationTaster, 
  Mutation Assessor, FATHMM, LRT, SiPhy, PhyloP) and the maximum frequency observed in 
  the 1000 genomes populations. Larger value means the SNV is more likely to be damaging. 
  Scores range from 0 to 1."
        />
      );

    case "MetaSVM":
      return (
        <HelperText
          customText="A support vector machine (SVM) based ensemble prediction score, which
  incorporated 10 scores (SIFT, PolyPhen-2 HDIV, PolyPhen-2 HVAR, GERP++, MutationTaster, 
  Mutation Assessor, FATHMM, LRT, SiPhy, PhyloP) and the maximum frequency observed in 
  the 1000 genomes populations. Larger value means the SNV is more likely to be damaging. 
  Scores range from -2 to 3 in dbNSFP."
        />
      );

    case "MetaRNN":
      return (
        <HelperText
          customText="A recurrent neural network (RNN) based ensemble prediction score, which
  incorporated 16 scores (SIFT, Polyphen2_HDIV, Polyphen2_HVAR, MutationAssessor, PROVEAN, 
  VEST4, M-CAP, REVEL, MutPred, MVP, PrimateAI, DEOGEN2, CADD, fathmm-XF, Eigen and GenoCanyon), 
  8 conservation scores (GERP, phyloP100way_vertebrate, phyloP30way_mammalian, 
  phyloP17way_primate, phastCons100way_vertebrate, phastCons30way_mammalian, 
  phastCons17way_primate and SiPhy), and allele frequency information from the 1000 Genomes 
  Project (1000GP), ExAC, and gnomAD. Larger value means the SNV is more likely to be damaging. 
  Scores range from 0 to 1."
        />
      );

    case "REVEL":
      return (
        <HelperText
          customText="REVEL is an ensemble score based on 13 individual scores for predicting the
  pathogenicity of missense variants. Scores range from 0 to 1. The larger the score the more 
  likely the SNP has damaging effect."
        />
      );

    case "EIGEN":
      return (
        <HelperText
          customText="Eigen score for coding SNVs. A functional prediction score based on conservation,
  allele frequencies, and deleteriousness prediction using an unsupervised learning method 
  (doi: 10.1038/ng.3477)."
        />
      );

    case "EIGEN PC":
      return (
        <HelperText
          customText="Eigen PC score for genome-wide SNVs. A functional prediction score based on
  conservation, allele frequencies, deleteriousness prediction (for missense SNVs) and
  epigenomic signals (for synonymous and non-coding SNVs) using an unsupervised learning 
  method (doi: 10.1038/ng.3477)."
        />
      );

    case "BLOSUM":
      return (
        <HelperText
          customText="Scores within a BLOSUM are log-odds scores that measure, in an alignment, 
    the logarithm for the ratio of the likelihood of two amino acids appearing with a biological sense and the 
    likelihood of the same amino acids appearing by chance. The matrices are based on the minimum percentage identity 
    of the aligned protein sequence used in calculating them. Every possible identity or substitution is assigned 
    a score based on its observed frequencies in the alignment of related proteins. A positive score is given to the 
    more likely substitutions while a negative score is given to the less likely substitutions."
        />
      );

    case "CADD":
      return (
        <HelperText
          customText="A CADD score represents a ranking not a prediction, and no threshold is defined for a 
  specific purpose. Higher scores are more likely to be deleterious: Scores are 10 * -log of the rank
so that variants with scores above 20 are predicted to be among the 1.0% most deleterious possible substitutions in the 
human genome. "
        />
      );

    case "AlphaMissense":
      return (
        <HelperText
          RenderContent={() => {
            return (
              <div>
                <p>
                  {`A continuous score between 0 and 1 which can be interpreted as the predicted probability of the variant being pathogenic. According to the initial paper the thresholds suggested are < 0.34 to indicate a 'Likely benign' variant and > 0.564 for 'Likely pathogenic', with 'ambiguous'  otherwise. More information on this score can be found`}
                  <span className="tw-px-1">
                    <a target="_blank" href={alphaMissenseUrl}>
                      here
                    </a>
                  </span>
                </p>
              </div>
            );
          }}
        />
      );

    default:
      return null;
  }
}
